export default async function CreateUnitApi(
  unitName,
  headUnitId,
  levelId,
  positionId,
  approverId
) {
  console.log(approverId);
  let res = "";
  try {
    const body = {
      name: unitName,
      headUnitId: headUnitId,
      levelId: levelId,
      positionId: positionId,
      approverId: approverId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/units/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error create unit: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
